"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _index = _interopRequireDefault(require("@/components/Store/RangePick/index.vue"));
var _myform = _interopRequireDefault(require("@/mixins/myform"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 新增门店计划自动分配时间，修改时间
 */
/** components */
/** mixins */
var _default2 = exports.default = {
  components: {
    RangePick: _index.default
  },
  mixins: [_myform.default],
  props: {
    targetForm: {
      type: Object,
      default: function _default() {
        return {
          storelist: []
        };
      }
    },
    actualPlanTaskFlag: {
      type: String,
      default: ''
    },
    planTaskDate: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      /** form group */
      formLabelWidth: '120px',
      pickerOptions: {
        start: '00:00',
        end: '23:30',
        step: '00:30'
      },
      rules: {
        validateChoose: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.emptySelect')
        }]
      }
    };
  },
  methods: {
    // 获取拍的
    getExcludeRange: function getExcludeRange(store) {
      var _this = this;
      return function () {
        var storeCode = store.storeCode;
        var arr = _this.targetForm.storelist.filter(function (i) {
          return i.storeCode !== storeCode;
        }).map(function (j) {
          return {
            start: j.planTaskStartTime,
            end: j.planTaskEndTime
          };
        });
        return arr;
      };
    },
    // 时间区间变动
    onRangeChange: function onRangeChange() {
      var _this2 = this;
      this.$nextTick(function () {
        // 数组监听有问题，临时处理下
        _this2.targetForm.storelist = (0, _toConsumableArray2.default)(_this2.targetForm.storelist);
      });
    },
    // 校验输入
    checkIpt: function () {
      var _checkIpt = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this3 = this;
        var valid;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.$refs['dataForm'].clearValidate();
              _context.n = 1;
              return this.$refs['dataForm'].validate().catch(function (err) {
                console.log('err错误', err);
                console.log(111, _this3.targetForm);
                return err;
              });
            case 1:
              valid = _context.v;
              if (!(valid !== true)) {
                _context.n = 2;
                break;
              }
              this.$message.error(this.$t('doubleWeekPlan.error.planRangeTime'));
              return _context.a(2, false);
            case 2:
              return _context.a(2, true);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function checkIpt() {
        return _checkIpt.apply(this, arguments);
      }
      return checkIpt;
    }(),
    // 定制错误处理
    errHandle: function errHandle(err) {
      var _this4 = this;
      var _ref = err || {},
        data = _ref.data,
        _ref$errorInfos = _ref.errorInfos,
        errorInfos = _ref$errorInfos === void 0 ? [] : _ref$errorInfos;
      var hasTimerangeErr = false;
      var timeErrMsg = '';
      this.errorHandle(err, 'dataForm', function () {
        errorInfos.forEach(function (item) {
          if (item.key === 'PlanTask_plan_time_conflicts') {
            // 针对时间区间冲突定制
            hasTimerangeErr = true;
            timeErrMsg = item.errMsg;
          }
        });
        // 针对时间区间冲突定制
        if (hasTimerangeErr) {
          (data || []).forEach(function (storeCode) {
            var keyStart = "".concat(storeCode, "_start");
            var keyEnd = "".concat(storeCode, "_end");
            _this4.errorKeys.push(keyStart);
            _this4.errorKeys.push(keyEnd);
            _this4.errorInfo[keyStart] = timeErrMsg;
            _this4.errorInfo[keyEnd] = " ";
          });
        }
      });
    },
    // 重置
    resetFields: function resetFields() {
      this.$refs['dataForm'].resetFields();
    }
  }
};